export default __webpack_public_path__ + "static/media/item-shoppinglist.7b14b6c6.png";